<template>
  <svg
    class="icon ui-clock-icon"
    :height="size"
    :width="size"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g style="stroke:currentColor;" stroke-width="1" fill="none" fill-rule="evenodd">
      <circle cx="8" cy="8" r="6.5" stroke-width="1"></circle>
      <line
        x1="8"
        y1="8"
        x2="8"
        y2="4"
        class="ui-clock-icon-minute"
        stroke-linecap="round"
        stroke-width="2"
        :style="{'animation-duration': spin && `${speed}s`}"
      />
      <line
        x1="8"
        y1="8"
        x2="10.61"
        y2="9.45"
        class="ui-clock-icon-hour"
        stroke-linecap="round"
        stroke-width="2"
        :style="{'animation-duration': spin && `${speed * 6}s`}"
      />

      <!-- <path d="M7.79906871,8.74988577 C7.79906871,8.74988577 8.79891641,8.73243336 10.7986118,8.69752855" id="hour-hand" stroke="#484A5B" stroke-linecap="round" transform="translate(9.2988, 8.7237) rotate(30) translate(-9.2988, -8.7237)"></path> -->
    </g>
  </svg>
</template>

<script setup>
import { baseIconProps } from '../base/use-base-icon.js';

defineProps({
  ...baseIconProps,
  speed: {
    type: Number,
    default: 2,
  }
});

</script>


<style lang="scss">

// minute hand!
.ui-clock-icon .ui-clock-icon-minute {
  -webkit-animation: icon--hands 2s infinite linear;
  animation: icon--hands 2s infinite linear;
  transform-origin: 8px 8px;
}

// hour hand
.ui-clock-icon .ui-clock-icon-hour {
  -webkit-animation: icon--hands 2s infinite linear;
  animation: icon--hands 12s infinite linear;
  transform-origin: 8px 8px;
}

@-webkit-keyframes icon--hands {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}


@keyframes icon--hands {
    0% {
    --webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    --webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

</style>
